import { styled } from '@mui/material';

export const Sections = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  overflow-y: auto;

  position: fixed;
  top: 65%;
  left: 0;
  right: 0;
  bottom: 0;
`;
